(() => {
  function setupForm(form) {
    if (form.dataset.productFormInitialized === 'true') return;

    form.dataset.productFormInitialized = 'true';

    const layout = form.closest('.pp-product-layout, .product-layout');
    const variantInputs = [...form.querySelectorAll('[data-variant-input]')];
    const addButton = form.querySelector('[data-add-to-cart]');
    const buttonText = form.querySelector('[data-add-to-cart-text]');
    const loadingText = form.querySelector('[data-add-to-cart-loading]');
    const errorMessage = form.querySelector('[data-product-form-error]');

    variantInputs.forEach((option) => option.addEventListener('change', () => {
      const price = layout?.querySelector('[data-product-price-current]');
      const comparePrice = layout?.querySelector('[data-product-compare-price]');
      const mainImage = layout?.querySelector('.pp-product-main-image, [data-product-main-image]');
      const available = option.dataset.available === 'true';

      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      if (mainImage && option.dataset.mediaSrc) {
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = option.dataset.mediaSrc;
        mainImage.alt = option.dataset.mediaAlt || mainImage.alt;
      }
      if (addButton && buttonText) {
        addButton.disabled = !available;
        buttonText.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
      }
      if (errorMessage) {
        errorMessage.hidden = true;
        errorMessage.textContent = '';
      }
    }));

    form.addEventListener('submit', async (event) => {
      if (event.submitter && event.submitter.name !== 'add') return;

      event.preventDefault();
      if (!addButton || addButton.disabled) return;

      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      if (buttonText) buttonText.hidden = true;
      if (loadingText) loadingText.hidden = false;
      if (errorMessage) {
        errorMessage.hidden = true;
        errorMessage.textContent = '';
      }

      try {
        const response = await fetch(form.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const result = await response.json();

        if (!response.ok) throw new Error(result.description || form.dataset.errorMessage);
        window.location.assign(form.dataset.cartUrl);
      } catch (error) {
        if (errorMessage) {
          errorMessage.textContent = error.message || form.dataset.errorMessage;
          errorMessage.hidden = false;
        }
        const selectedVariant = form.querySelector('[data-variant-input]:checked');
        addButton.disabled = selectedVariant ? selectedVariant.dataset.available !== 'true' : false;
      } finally {
        addButton.removeAttribute('aria-busy');
        if (buttonText) buttonText.hidden = false;
        if (loadingText) loadingText.hidden = true;
      }
    });
  }

  function setupAll(root = document) {
    if (root instanceof Element && root.matches('[data-product-form]')) setupForm(root);
    root.querySelectorAll?.('[data-product-form]').forEach(setupForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll(), { once: true });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
